const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Reynolds Transport Theorem ─────────────────────────
function DiagramRTT() {
  const W = 680, H = 260;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Reynolds Transport Theorem — System vs Control Volume</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrRTT" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrRTTR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrRTTG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* System boundary (Lagrangian) — dashed oval */}
        <ellipse cx="170" cy="130" rx="130" ry="88"
          fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.8" strokeDasharray="7 4"/>
        <text x="170" y="60" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#2980b9">System</text>
        <text x="170" y="76" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9" fontStyle="italic">(fixed mass — Lagrangian)</text>
        <text x="170" y="136" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fill="#2980b9">dB_sys/dt</text>
        <text x="170" y="154" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">rate of change of</text>
        <text x="170" y="169" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">property B in system</text>

        {/* Equals sign */}
        <text x="328" y="136" textAnchor="middle" fontFamily="Georgia,serif" fontSize="28" fontWeight="700" fill="#7B0D0D">=</text>

        {/* Control volume (Eulerian) — solid rect */}
        <rect x="362" y="42" width="278" height="176" rx="10"
          fill="#f0fff4" stroke="#27ae60" strokeWidth="1.8"/>
        <text x="501" y="66" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#27ae60">Control Volume</text>
        <text x="501" y="82" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#27ae60" fontStyle="italic">(fixed in space — Eulerian)</text>

        {/* CV term 1 — storage */}
        <rect x="374" y="94" width="254" height="48" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="501" y="114" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">∂/∂t ∫∫∫_CV ρb dV</text>
        <text x="501" y="132" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">rate of change of B inside CV</text>

        <text x="501" y="156" textAnchor="middle" fontFamily="Georgia,serif" fontSize="16" fill="#7B0D0D">+</text>

        {/* CV term 2 — flux */}
        <rect x="374" y="162" width="254" height="48" rx="6" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1"/>
        <text x="501" y="182" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#2980b9">∯_CS ρb (V·n̂) dA</text>
        <text x="501" y="200" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">net flux of B out through CS</text>

        {/* Flux arrows on CV faces */}
        <line x1="362" y1="130" x2="310" y2="130" stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#arrRTTR)"/>
        <text x="318" y="124" fontFamily="Georgia,serif" fontSize="10" fill="#c0392b">in</text>
        <line x1="640" y1="130" x2="666" y2="130" stroke="#27ae60" strokeWidth="1.5" markerEnd="url(#arrRTTG)"/>
        <text x="650" y="124" fontFamily="Georgia,serif" fontSize="10" fill="#27ae60">out</text>

        {/* b label */}
        <text x="340" y="240" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#888" fontStyle="italic">b = B per unit mass   (b=1 → continuity;  b=V → momentum;  b=e → energy)</text>
      </svg>
      <div style={S.dCaption}>
        The Reynolds Transport Theorem (RTT) converts a system-based (Lagrangian) conservation law into a control-volume (Eulerian) statement.
        The rate of change of any extensive property B equals the rate of change stored inside the CV plus the net flux of B out through the control surface CS.
      </div>
    </div>
  );
}

// ── Diagram 2: Linear Momentum — pipe bend ────────────────────────
function DiagramPipeBend() {
  const W = 680, H = 310;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Linear Momentum Equation — Forces on a 90° Pipe Bend</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrPB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrPBR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrPBG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
          <marker id="arrPBGr" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* Pipe bend shape */}
        <path d="M 40 100 L 260 100 Q 320 100 320 160 L 320 290"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 40 140 L 260 140 Q 280 140 280 160 L 280 290"
          fill="none" stroke="#7B0D0D" strokeWidth="2.5" strokeLinecap="round"/>
        {/* Fluid fill */}
        <path d="M 40 100 L 260 100 Q 320 100 320 160 L 320 290 L 280 290 L 280 160 Q 280 140 260 140 L 40 140 Z"
          fill="#2980b9" opacity="0.12"/>

        {/* Inlet velocity V₁ (horizontal) */}
        <line x1="56" y1="120" x2="106" y2="120" stroke="#2980b9" strokeWidth="2.4" markerEnd="url(#arrPB)"/>
        <text x="48" y="88" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#2980b9">V₁, A₁</text>
        <text x="48" y="104" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9" fontStyle="italic">→ x-direction</text>

        {/* Outlet velocity V₂ (downward) */}
        <line x1="300" y1="210" x2="300" y2="260" stroke="#c0392b" strokeWidth="2.4" markerEnd="url(#arrPBR)"/>
        <text x="328" y="228" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#c0392b">V₂, A₂</text>
        <text x="328" y="244" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b" fontStyle="italic">↓ −y direction</text>

        {/* Section labels */}
        <line x1="40"  y1="92"  x2="40"  y2="148" stroke="#aaa" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="40"  y="162" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">①</text>
        <line x1="290" y1="290" x2="322" y2="290" stroke="#aaa" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="340" y="292" fontFamily="Georgia,serif" fontSize="11" fill="#555">②</text>

        {/* Reaction forces on bend */}
        {/* Fx (reaction from bend on fluid, pointing left for typical case) */}
        <line x1="200" y1="120" x2="148" y2="120" stroke="#27ae60" strokeWidth="2.2" markerEnd="url(#arrPBG)"/>
        <text x="148" y="108" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#27ae60">R_x</text>

        {/* Fy (reaction upward — bend pushes fluid down, fluid pushes bend up) */}
        <line x1="300" y1="170" x2="300" y2="130" stroke="#27ae60" strokeWidth="2.2" markerEnd="url(#arrPBG)"/>
        <text x="316" y="148" fontFamily="Courier New,monospace" fontSize="11" fill="#27ae60">R_y</text>

        {/* Weight arrow */}
        <line x1="170" y1="110" x2="170" y2="148" stroke="#888" strokeWidth="1.4" markerEnd="url(#arrPBR)"/>
        <text x="180" y="136" fontFamily="Courier New,monospace" fontSize="10" fill="#888">W</text>

        {/* Momentum equation box */}
        <rect x="374" y="60" width="286" height="200" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="517" y="84" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">Momentum Equation</text>
        <line x1="384" y1="92" x2="650" y2="92" stroke="#f0cece" strokeWidth="1"/>

        <text x="517" y="112" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">ΣF = ṁ(V_out − V_in)</text>
        <text x="517" y="130" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">(steady, uniform at CS)</text>

        <line x1="384" y1="140" x2="650" y2="140" stroke="#f0cece" strokeWidth="1"/>

        <text x="517" y="158" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">x-direction:</text>
        <text x="517" y="176" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">P₁A₁ + R_x = ṁ(0 − V₁)</text>
        <text x="517" y="193" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D">R_x = −ṁV₁ − P₁A₁</text>

        <line x1="384" y1="202" x2="650" y2="202" stroke="#f0cece" strokeWidth="1"/>

        <text x="517" y="220" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">y-direction:</text>
        <text x="517" y="238" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">−P₂A₂ + R_y − W = ṁ(−V₂ − 0)</text>
        <text x="517" y="255" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D">R_y = −ṁV₂ + P₂A₂ + W</text>
      </svg>
      <div style={S.dCaption}>
        The momentum equation applied to the bend control volume. The fluid enters horizontally (x) and exits downward (−y).
        The change in momentum direction requires a net force from the bend walls. R_x and R_y are the reaction forces the bend exerts on the fluid;
        the force on the bend from the fluid is equal and opposite — used in pipe support design.
      </div>
    </div>
  );
}

// ── Diagram 3: Jet impingement on a flat plate ────────────────────
function DiagramJetImpingement() {
  const W = 680, H = 280;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Jet Impingement — Force on a Stationary Flat Plate</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrJI" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrJIR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrJIG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* === Normal impingement (left) === */}
        {/* Incoming jet */}
        <rect x="116" y="40" width="28" height="120" rx="4" fill="#2980b9" opacity="0.30"/>
        <line x1="130" y1="50"  x2="130" y2="100" stroke="#2980b9" strokeWidth="2.2" markerEnd="url(#arrJI)"/>
        <text x="130" y="34" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#2980b9">V, A</text>

        {/* Flat plate */}
        <rect x="60" y="158" width="140" height="14" rx="3" fill="#e8e0d0" stroke="#7B0D0D" strokeWidth="1.8"/>
        <text x="130" y="188" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#7B0D0D">flat plate</text>

        {/* Deflected jets (spreading sideways) */}
        <path d="M 130 158 C 108 158 72 150 50 140" fill="none" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrJI)" opacity="0.7"/>
        <path d="M 130 158 C 152 158 188 150 210 140" fill="none" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrJI)" opacity="0.7"/>

        {/* Force on plate arrow */}
        <line x1="130" y1="172" x2="130" y2="220" stroke="#c0392b" strokeWidth="2.8" markerEnd="url(#arrJIR)"/>
        <text x="148" y="204" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#c0392b">F = ṁV</text>
        <text x="148" y="220" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b">= ρAV²</text>

        <text x="130" y="256" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#555">Normal impingement</text>
        <text x="130" y="271" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#888">jet deflected 90°</text>

        {/* Vertical separator */}
        <line x1="250" y1="30" x2="250" y2="270" stroke="#ddd" strokeWidth="1" strokeDasharray="4 3"/>

        {/* === Moving plate (right) === */}
        {/* Incoming jet */}
        <rect x="386" y="40" width="28" height="100" rx="4" fill="#2980b9" opacity="0.30"/>
        <line x1="400" y1="50" x2="400" y2="100" stroke="#2980b9" strokeWidth="2.2" markerEnd="url(#arrJI)"/>
        <text x="400" y="34" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#2980b9">V</text>

        {/* Moving plate */}
        <rect x="330" y="136" width="140" height="14" rx="3" fill="#e8e0d0" stroke="#7B0D0D" strokeWidth="1.8"/>
        {/* Plate velocity arrow */}
        <line x1="330" y1="143" x2="290" y2="143" stroke="#27ae60" strokeWidth="2" markerEnd="url(#arrJIG)"/>
        <text x="276" y="140" textAnchor="end" fontFamily="Courier New,monospace" fontSize="11" fill="#27ae60">u</text>
        <text x="400" y="166" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#7B0D0D">moving plate (velocity u)</text>

        {/* Deflected jets */}
        <path d="M 400 136 C 372 136 342 128 318 118" fill="none" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrJI)" opacity="0.7"/>
        <path d="M 400 136 C 428 136 458 128 482 118" fill="none" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrJI)" opacity="0.7"/>

        {/* Force */}
        <line x1="400" y1="150" x2="400" y2="200" stroke="#c0392b" strokeWidth="2.8" markerEnd="url(#arrJIR)"/>
        <text x="420" y="178" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#c0392b">F = ρA(V−u)²</text>

        {/* Power */}
        <text x="400" y="226" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#27ae60">Power = Fu = ρA(V−u)²u</text>
        <text x="400" y="256" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#555">Moving plate</text>
        <text x="400" y="271" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#888">relative velocity = V − u</text>

        {/* Formula box top-right */}
        <rect x="520" y="36" width="148" height="66" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="594" y="56" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">ΣF_x = ṁΔV_x</text>
        <line x1="530" y1="65" x2="658" y2="65" stroke="#f0cece" strokeWidth="1"/>
        <text x="594" y="80" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">x-momentum in = ṁV</text>
        <text x="594" y="95" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">x-momentum out = 0</text>
      </svg>
      <div style={S.dCaption}>
        Left: stationary plate — jet enters at V, deflects sideways at zero x-momentum; force F = ρAV².
        Right: plate moving at speed u — effective jet velocity is (V−u); force F = ρA(V−u)². Maximum power transfer occurs at u = V/3.
        Both cases use the x-momentum equation: ΣF_x = ṁ(V_out,x − V_in,x).
      </div>
    </div>
  );
}

// ── Diagram 4: Force on a Moving Vane ────────────────────────────
function DiagramMovingVane() {
  const W = 680, H = 270;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Force on a Curved Moving Vane — Pelton Wheel Bucket Analysis</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrMV" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrMVR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrMVG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* Relative velocity frame */}
        <rect x="30" y="28" width="300" height="220" rx="8" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.2"/>
        <text x="180" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#2980b9">Relative (moving) frame</text>

        {/* Vane shape — curved bucket */}
        <path d="M 60 140 Q 90 100 140 100 Q 190 100 210 140 Q 190 180 140 180 Q 90 180 60 140 Z"
          fill="#e8e0d0" stroke="#7B0D0D" strokeWidth="2"/>

        {/* Relative inlet velocity (w₁ = V - u) */}
        <line x1="52" y1="140" x2="58" y2="140" stroke="#2980b9" strokeWidth="2.4" markerEnd="url(#arrMV)"/>
        <line x1="30" y1="140" x2="56" y2="140" stroke="#2980b9" strokeWidth="2.4"/>
        <text x="30" y="128" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9" fontWeight="700">w₁ = V−u →</text>

        {/* Relative exit velocity (w₂ turned by angle β) */}
        <line x1="208" y1="130" x2="252" y2="106" stroke="#c0392b" strokeWidth="2.4" markerEnd="url(#arrMVR)"/>
        <text x="256" y="102" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b" fontWeight="700">w₂ (at β)</text>

        {/* β angle arc */}
        <path d="M 218 130 Q 222 118 228 112" fill="none" stroke="#888" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="232" y="130" fontFamily="Georgia,serif" fontSize="11" fill="#888">β</text>

        {/* Vane velocity u */}
        <line x1="90" y1="200" x2="180" y2="200" stroke="#27ae60" strokeWidth="2" markerEnd="url(#arrMVG)"/>
        <text x="100" y="218" fontFamily="Courier New,monospace" fontSize="11" fill="#27ae60">vane velocity u →</text>

        {/* Right panel — absolute frame & forces */}
        <rect x="358" y="28" width="290" height="220" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="503" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">Force Analysis</text>
        <line x1="368" y1="58" x2="638" y2="58" stroke="#f0cece" strokeWidth="1"/>

        <text x="503" y="80" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">In relative frame,  |w₁| = |w₂| = (V−u)</text>
        <text x="503" y="96" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">(frictionless vane assumption)</text>

        <line x1="368" y1="106" x2="638" y2="106" stroke="#f0cece" strokeWidth="1"/>

        <text x="503" y="124" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">F_x = ṁ_rel (V−u)(1−cosβ)</text>
        <text x="503" y="142" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">F_y = ṁ_rel (V−u) sinβ</text>

        <line x1="368" y1="152" x2="638" y2="152" stroke="#f0cece" strokeWidth="1"/>

        <text x="503" y="170" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Power = F_x · u = ṁ_rel (V−u)²(1−cosβ) u</text>

        <line x1="368" y1="182" x2="638" y2="182" stroke="#f0cece" strokeWidth="1"/>

        <text x="503" y="200" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Max power: u = V/2,  β = 180°</text>
        <text x="503" y="217" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D">η_max = 100% (ideal Pelton)</text>
        <text x="503" y="234" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#888">(practical: β ≈ 165°, η ≈ 85–90%)</text>
      </svg>
      <div style={S.dCaption}>
        Analysis in the relative (moving) frame: the jet enters at relative velocity w₁ = V−u, is turned through angle β by the vane,
        and exits at w₂. For a frictionless vane |w₁| = |w₂|. The x-force on the vane drives rotation; maximum power occurs at u = V/2 with β = 180°.
        This is the basis of the Pelton wheel impulse turbine.
      </div>
    </div>
  );
}

// ── Diagram 5: Angular Momentum — centrifugal pump ────────────────
function DiagramAngularMomentum() {
  const W = 680, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Angular Momentum — Euler Turbomachine Equation</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrAM" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrAMR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrAMG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* Impeller circle */}
        <circle cx="200" cy="148" r="110" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.5" strokeDasharray="6 3" opacity="0.7"/>
        <circle cx="200" cy="148" r="46"  fill="#fff" stroke="#7B0D0D" strokeWidth="2"/>
        <text x="200" y="144" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#7B0D0D" fontWeight="700">impeller</text>
        <text x="200" y="158" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#7B0D0D">ω</text>

        {/* Rotation arrow */}
        <path d="M 200 102 Q 242 102 242 148" fill="none" stroke="#7B0D0D" strokeWidth="1.5" markerEnd="url(#arrAMR)"/>

        {/* Inlet (r₁, small radius) */}
        <circle cx="200" cy="148" r="3" fill="#555"/>
        <line x1="200" y1="148" x2="200" y2="104" stroke="#555" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="214" y="128" fontFamily="Courier New,monospace" fontSize="10" fill="#555">r₁</text>
        {/* Inlet velocity triangle */}
        <line x1="200" y1="104" x2="228" y2="86" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrAM)"/>
        <text x="232" y="82" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9">V₁ (V_θ1≈0)</text>
        <line x1="200" y1="104" x2="228" y2="104" stroke="#27ae60" strokeWidth="1.4" strokeDasharray="4 2" markerEnd="url(#arrAMG)"/>
        <text x="232" y="102" fontFamily="Courier New,monospace" fontSize="10" fill="#27ae60">u₁=ωr₁</text>

        {/* Outlet (r₂, large radius) */}
        <line x1="200" y1="148" x2="94"  y2="68" stroke="#555" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="108" y="88" fontFamily="Courier New,monospace" fontSize="10" fill="#555">r₂</text>
        {/* Outlet velocity triangle */}
        <line x1="94" y1="68" x2="50" y2="44" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrAMR)"/>
        <text x="34" y="38" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b">V₂</text>
        <line x1="94" y1="68" x2="50" y2="68" stroke="#27ae60" strokeWidth="1.4" strokeDasharray="4 2" markerEnd="url(#arrAMG)"/>
        <text x="40" y="82" fontFamily="Courier New,monospace" fontSize="10" fill="#27ae60">u₂=ωr₂</text>
        {/* Tangential component V_θ2 */}
        <line x1="94" y1="68" x2="94" y2="44" stroke="#c0392b" strokeWidth="1.4" strokeDasharray="4 2"/>
        <text x="100" y="54" fontFamily="Courier New,monospace" fontSize="10" fill="#c0392b">V_θ2</text>

        {/* Fluid path (spiral) */}
        <path d="M 200 102 Q 160 80 130 90 Q 80 100 80 148 Q 80 200 130 218 Q 180 240 240 220 Q 300 200 310 148"
          fill="none" stroke="#2980b9" strokeWidth="1.2" strokeDasharray="5 3" opacity="0.6"/>

        {/* Right panel — Euler equation */}
        <rect x="355" y="38" width="308" height="220" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="509" y="62" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">Euler Turbomachine Equation</text>
        <line x1="365" y1="70" x2="653" y2="70" stroke="#f0cece" strokeWidth="1"/>

        <text x="509" y="92" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">T = ṁ(r₂V_θ2 − r₁V_θ1)</text>
        <text x="509" y="110" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">T = torque on fluid [N·m]</text>

        <line x1="365" y1="120" x2="653" y2="120" stroke="#f0cece" strokeWidth="1"/>

        <text x="509" y="140" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">W = ṁω(r₂V_θ2 − r₁V_θ1)</text>
        <text x="509" y="158" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">  = ṁ(u₂V_θ2 − u₁V_θ1)</text>

        <line x1="365" y1="168" x2="653" y2="168" stroke="#f0cece" strokeWidth="1"/>

        <text x="509" y="188" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Head delivered (pump):</text>
        <text x="509" y="206" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">H = (u₂V_θ2 − u₁V_θ1)/g</text>

        <line x1="365" y1="216" x2="653" y2="216" stroke="#f0cece" strokeWidth="1"/>

        <text x="509" y="234" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">V_θ1 ≈ 0 (radial inlet, no swirl)</text>
        <text x="509" y="250" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D">H = u₂V_θ2/g</text>
      </svg>
      <div style={S.dCaption}>
        Angular momentum (moment of momentum) equation applied to a centrifugal pump impeller. Fluid enters at radius r₁ (nearly radially,
        V_θ1 ≈ 0) and exits at r₂ with tangential component V_θ2 = u₂ − w_θ2. The Euler equation gives the ideal head delivered.
        The same equation applies to turbines (torque extracted) by reversing the sign.
      </div>
    </div>
  );
}

// ── Diagram 6: Navier-Stokes simplified — Couette & Poiseuille ────
function DiagramNavierStokes() {
  const W = 680, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Navier-Stokes Simplified — Couette Flow &amp; Poiseuille Flow Profiles</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrNS" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrNSR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* === Couette Flow (left) === */}
        <rect x="30" y="28" width="280" height="240" rx="8" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.2"/>
        <text x="170" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#2980b9">Couette Flow</text>
        <text x="170" y="66" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">moving top wall drives flow</text>

        {/* Moving top plate */}
        <rect x="50" y="76" width="240" height="12" rx="3" fill="#c0392b" opacity="0.8"/>
        <line x1="168" y1="76" x2="232" y2="76" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrNSR)"/>
        <text x="290" y="84" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b">U</text>

        {/* Fixed bottom plate */}
        <rect x="50" y="216" width="240" height="12" rx="3" fill="#7B0D0D" opacity="0.5"/>
        <text x="170" y="242" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">fixed wall  (u = 0)</text>

        {/* Velocity profile — linear */}
        {[0,0.25,0.5,0.75,1.0].map((frac, i) => {
          const y = 88 + frac * 128;
          const len = 12 + frac * 76;
          return (
            <line key={i} x1="62" y1={y} x2={62 + len} y2={y}
              stroke="#2980b9" strokeWidth={1.2 + frac*0.8} markerEnd="url(#arrNS)" opacity="0.8"/>
          );
        })}
        {/* Profile envelope line */}
        <line x1="62" y1="88" x2="138" y2="216" stroke="#7B0D0D" strokeWidth="1.2" strokeDasharray="4 2"/>

        {/* h annotation */}
        <line x1="36" y1="88"  x2="36" y2="216" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrNS)" markerStart="url(#arrNSR)"/>
        <text x="24" y="156" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#555">h</text>

        {/* Formula */}
        <rect x="50" y="190" width="240" height="24" rx="4" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="170" y="206" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">u(y) = U·y/h</text>

        {/* === Poiseuille Flow (right) === */}
        <rect x="370" y="28" width="280" height="240" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="510" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">Hagen-Poiseuille Flow</text>
        <text x="510" y="66" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">pressure gradient drives flow</text>

        {/* Top wall */}
        <rect x="390" y="76" width="240" height="10" rx="3" fill="#7B0D0D" opacity="0.4"/>
        <text x="510" y="72" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">u = 0 (no-slip)</text>

        {/* Bottom wall */}
        <rect x="390" y="218" width="240" height="10" rx="3" fill="#7B0D0D" opacity="0.4"/>
        <text x="510" y="244" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">u = 0 (no-slip)</text>

        {/* Parabolic velocity profile */}
        {/* Arrows at several y positions */}
        {[-1,-0.75,-0.5,-0.25,0,0.25,0.5,0.75,1.0].map((eta, i) => {
          const centerY = 148;
          const halfH = 70;
          const y = centerY + eta * halfH;
          const len = (1 - eta*eta) * 90;
          if (len < 2) return null;
          return (
            <line key={i} x1="400" y1={y} x2={400 + len} y2={y}
              stroke="#c0392b" strokeWidth={0.8 + (1-Math.abs(eta))*1.4} markerEnd="url(#arrNSR)" opacity="0.75"/>
          );
        })}

        {/* Parabola envelope */}
        <path d="M 400 86 Q 490 148 400 210" fill="none" stroke="#7B0D0D" strokeWidth="1.2" strokeDasharray="4 2"/>

        {/* Pressure gradient arrow */}
        <line x1="584" y1="108" x2="618" y2="108" stroke="#27ae60" strokeWidth="1.5" markerEnd="url(#arrNS)"/>
        <text x="578" y="102" textAnchor="end" fontFamily="Courier New,monospace" fontSize="10" fill="#27ae60">−dP/dx</text>

        {/* R annotation */}
        <line x1="382" y1="148" x2="382" y2="86" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrNS)" markerStart="url(#arrNSR)"/>
        <text x="370" y="120" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#555">R</text>

        {/* Formula */}
        <rect x="390" y="190" width="240" height="26" rx="4" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1"/>
        <text x="510" y="207" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#2980b9">u(r) = (R²−r²)/(4μ) · (−dP/dx)</text>
      </svg>
      <div style={S.dCaption}>
        Left — Couette flow: viscous shear between moving and stationary walls; linear profile u = Uy/h; no pressure gradient needed.
        Right — Hagen-Poiseuille flow: pressure gradient drives flow through a circular pipe; parabolic profile with u_max = R²(−dP/dx)/(4μ) at centreline.
        Both are exact analytical solutions to the Navier-Stokes equations for fully developed laminar flow.
      </div>
    </div>
  );
}

// ── Main export ───────────────────────────────────────────────────
export default function MomentumAndForces() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Momentum &amp; Forces</h1>
      <p style={S.p}>
        The momentum equation is Newton's second law applied to fluid flow. Combined with the Reynolds
        Transport Theorem it converts Lagrangian particle mechanics into a powerful Eulerian control-volume
        tool for computing forces on pipe bends, nozzles, vanes, turbomachinery, and any surface
        in contact with a moving fluid.
      </p>

      <InfoBox title="CORE CONCEPTS OVERVIEW" items={[
        "Reynolds Transport Theorem — converts system (Lagrangian) conservation to control-volume (Eulerian) form",
        "Linear momentum equation — ΣF = d(mV)/dt; for steady flow ΣF = ṁ(V_out − V_in)",
        "Forces on pipe bends — pressure and momentum flux both contribute; support loads calculated by x/y components",
        "Jet impingement — force on plates, vanes, and nozzles from momentum change of a jet",
        "Moving vanes — relative velocity (V−u) governs force; maximum power at u = V/2 for flat plate",
        "Angular momentum — Euler turbomachine equation: T = ṁ(r₂V_θ2 − r₁V_θ1)",
        "Navier-Stokes equations — general momentum equations for viscous flow; Couette and Poiseuille as exact solutions",
      ]}/>

      {/* ── Reynolds Transport Theorem ── */}
      <h2 style={S.h2}>Reynolds Transport Theorem</h2>
      <p style={S.p}>
        The Reynolds Transport Theorem (RTT) is the bridge between the Lagrangian conservation laws of
        classical mechanics and the Eulerian control-volume approach used in engineering fluid mechanics.
        Every conservation equation — mass, momentum, energy — takes the same structural form via the RTT.
      </p>
      <DiagramRTT/>
      <Table2 rows={[
        ["RTT — general form",
`dB_sys/dt = ∂/∂t ∫∫∫_CV ρb dV  +  ∯_CS ρb(V·n̂) dA
B = any extensive property (mass, momentum, energy…)
b = B per unit mass (b=1, V, e for mass, momentum, energy)
n̂ = outward unit normal on control surface`],
        ["Physical interpretation",
`Left side: rate of change of B in the system (follows fluid parcels)
Term 1 (right): rate of accumulation of B inside the fixed CV
Term 2 (right): net flux of B leaving through the control surface
For steady flow: ∂/∂t term = 0`],
        ["Applying RTT to momentum (b = V)",
`ΣF_external = ∂/∂t ∫∫∫_CV ρV dV  +  ∯_CS ρV(V·n̂) dA
For steady, uniform flow at inlet/outlet:
ΣF = Σ(ṁV)_out − Σ(ṁV)_in`],
        ["External forces included in ΣF",
`Pressure forces on CS:  ∯ P n̂ dA  (act inward on fluid)
Body forces (gravity):   ∫∫∫ ρg dV = W_fluid
Reaction forces from walls/supports on fluid (R)
ΣF = F_pressure + W + R`],
      ]}/>

      {/* ── Linear Momentum ── */}
      <h2 style={S.h2}>Linear Momentum Equation</h2>
      <p style={S.p}>
        For steady flow with uniform velocity at inlet and outlet, the integral momentum equation reduces
        to a simple vector statement: the net external force on the fluid in a control volume equals the
        net rate of momentum leaving the control volume.
      </p>
      <Table2 rows={[
        ["Steady-flow momentum equation",
`ΣF = Σṁ_out V_out − Σṁ_in V_in
Applied as separate x, y, z scalar equations
ṁ = ρAV = mass flow rate [kg/s]`],
        ["Forces acting on fluid in CV",
`1. Pressure forces at inlet/outlet cross-sections: P·A (inward)
2. Reaction force R from walls, bends, nozzles on fluid
3. Body force W = ρVol·g (usually negligible in pipe flows)
Solve for R; force on structure = −R (Newton's 3rd law)`],
        ["Sign convention",
`Choose positive x and y directions
Inlet momentum flux: negative (entering CV, − in RTT flux term)
Outlet momentum flux: positive (leaving CV, + in RTT flux term)
Pressure at CS: always acts inward on fluid → add +P·A at inlets`],
        ["Force on a nozzle",
`x:  P₁A₁ − P₂A₂ + R_x = ṁV₂cosθ − ṁV₁
For straight nozzle (θ=0): R_x = ṁ(V₂ − V₁) − P₁A₁ + P₂A₂
Nozzle reaction tensile (pulls nozzle toward pipe) for typical cases`],
        ["Momentum correction factor β",
`Accounts for non-uniform velocity profile at cross-section
β = ∫u²dA / (V̄²A)  [dimensionless]
Laminar pipe flow: β = 4/3;  turbulent: β ≈ 1.01–1.05
Modified equation: ΣF = β₂ṁV₂ − β₁ṁV₁`],
      ]}/>

      {/* ── Pipe Bend ── */}
      <h2 style={S.h2}>Forces on Pipe Bends &amp; Fittings</h2>
      <p style={S.p}>
        A pipe bend changes the direction of momentum flux, requiring a net force from the bend walls.
        Engineers must calculate these forces to size pipe supports, anchor bolts, and expansion joints.
        Both pressure forces and momentum flux changes contribute to the resultant.
      </p>
      <DiagramPipeBend/>
      <Table2 rows={[
        ["90° pipe bend (horizontal to downward)",
`x: P₁A₁ + R_x = ṁ(0) − ṁV₁  →  R_x = −ṁV₁ − P₁A₁
y: R_y − P₂A₂ − W = ṁ(−V₂) − 0  →  R_y = P₂A₂ + W − ṁV₂
Resultant force on bend from fluid: F = −R (Newton's 3rd law)`],
        ["General bend angle θ",
`x: P₁A₁ − P₂A₂cosθ + R_x = ṁV₂cosθ − ṁV₁
y: P₂A₂sinθ + R_y = ṁV₂sinθ − 0
Magnitude: F_R = √(R_x² + R_y²)`],
        ["Effect of gauge vs absolute pressure",
`Use gauge pressures throughout (atmospheric cancels)
OR use absolute — but must include P_atm on all external surfaces
Gauge pressure approach is simpler for enclosed pipe flows`],
        ["Reducing bend (A₂ ≠ A₁)",
`Continuity: V₂ = V₁(A₁/A₂);  Bernoulli gives P₂ from P₁
Both higher velocity and lower pressure at outlet affect forces
Use same momentum equation — forces larger than constant-area bend`],
        ["Pipe anchoring",
`Supports must resist calculated R (reaction on bend from fluid)
Plus weight of pipe, fittings, and contained fluid
Thermal expansion loads added separately in design`],
      ]}/>

      {/* ── Jet Impingement ── */}
      <h2 style={S.h2}>Jet Impingement — Forces on Plates &amp; Vanes</h2>
      <p style={S.p}>
        When a free jet strikes a surface, momentum is transferred and a force is exerted. This is the
        operating principle of Pelton turbines, lawn sprinklers, jet pumps, and rocket nozzles.
        The analysis distinguishes between stationary and moving targets.
      </p>
      <DiagramJetImpingement/>
      <Table2 rows={[
        ["Stationary flat plate (normal)",
`Jet enters at V, leaves tangentially (V_x,out = 0)
x-momentum: F = ṁV = ρAV²
No pressure force (free jet, P_gauge = 0 at all surfaces)
Force is entirely from momentum change`],
        ["Stationary inclined plate (angle α)",
`Tangential momentum conserved (no friction):
F_normal = ρAV² sinα  (normal to plate)
F_x = ρAV² sin²α,  F_y = ρAV² sinα cosα
Split flow: ṁ₁ = ṁ(1+cosα)/2,  ṁ₂ = ṁ(1−cosα)/2`],
        ["Moving flat plate (velocity u)",
`Relative velocity = V − u (in moving frame)
F = ρA(V−u)²  (force on plate)
Power = F·u = ρA(V−u)²u
Maximum power: dP/du = 0  →  u = V/3  (stationary jet analysis)`],
        ["Series of vanes (continuous jet)",
`ṁ_relative = ρA(V−u)  (all fluid always striking a vane)
F = ρA(V−u)·(V−u) = ρA(V−u)²  (same as single plate)
Power = ρA(V−u)²u;  max power at u = V/2 (not V/3)
This is the case for a Pelton wheel with many buckets`],
        ["Curved vane — deflection angle β",
`F_x = ṁ_rel(V−u)(1 − cosβ)
F_y = ṁ_rel(V−u)sinβ
β = 180° (full U-turn): F_x = 2ṁ_rel(V−u)  (maximum force)
Pelton wheel: β ≈ 165° to allow bucket exit clearance`],
      ]}/>

      {/* ── Moving Vane ── */}
      <h2 style={S.h2}>Moving Curved Vanes &amp; Turbomachinery</h2>
      <p style={S.p}>
        The analysis of moving vanes — the basis of all turbomachinery — is best performed in the rotating
        (relative) reference frame where the vane appears stationary. The relative velocity replaces the
        absolute velocity, and the Euler turbomachine equation connects torque to angular momentum.
      </p>
      <DiagramMovingVane/>
      <Table2 rows={[
        ["Reference frame transformation",
`Absolute velocity:  V = w + u
w = relative velocity (in vane frame),  u = vane speed = ωr
In relative frame: vane stationary, jet arrives at w = V − u
Continuity and momentum applied with relative velocities`],
        ["Frictionless vane assumption",
`|w₁| = |w₂| = (V−u)  (speed unchanged, only direction changes)
Only direction turns by angle β
Friction accounted for by efficiency factor η_vane`],
        ["Work done by jet on vane",
`W_per_unit_mass = u₁w_θ1 − u₂w_θ2
= u(V−u)(1 − cosβ)  (for flat or curved plate, u₁=u₂=u)
Hydraulic efficiency: η_h = u(V−u)(1−cosβ) / (V²/2)`],
        ["Euler turbomachine equation",
`T = ṁ(r₂V_θ2 − r₁V_θ1)  [N·m]
W = Tω = ṁ(u₂V_θ2 − u₁V_θ1)  [W]
H_Euler = (u₂V_θ2 − u₁V_θ1)/g  [m]  (ideal head for pump)`],
        ["Velocity triangle construction",
`At any radius: V = u + w  (vector addition)
u = blade speed (tangential);  V = absolute velocity;  w = relative
V_θ = tangential component of absolute velocity
Used to design blade angles for pumps and turbines`],
      ]}/>

      {/* ── Angular Momentum ── */}
      <h2 style={S.h2}>Angular Momentum Equation</h2>
      <p style={S.p}>
        The angular momentum (moment of momentum) equation is the rotational analogue of the linear
        momentum equation. It is the fundamental tool for analysing all turbomachinery — pumps, fans,
        compressors, and turbines.
      </p>
      <DiagramAngularMomentum/>
      <Table2 rows={[
        ["Angular momentum equation",
`ΣM = ∂/∂t ∫∫∫_CV r×(ρV) dV  +  ∯_CS r×V · ρ(V·n̂) dA
For steady flow:  T_shaft = ṁ(r₂V_θ2 − r₁V_θ1)`],
        ["Euler turbomachine equation",
`T = ṁ(r₂V_θ2 − r₁V_θ1)
W = Tω = ṁ(u₂V_θ2 − u₁V_θ1)  where u = ωr
H_Euler = W/(ṁg) = (u₂V_θ2 − u₁V_θ1)/g  [m of head]`],
        ["Centrifugal pump (no inlet swirl, V_θ1=0)",
`H_Euler = u₂V_θ2/g
V_θ2 = u₂ − w_θ2 = u₂ − (Q/A₂)/tanβ₂
β₂ = blade exit angle;  A₂ = impeller exit area`],
        ["Axial flow turbine/compressor",
`Fluid flows axially; swirl component V_θ changes across rotor
T = ṁ r(V_θ2 − V_θ1)  (same r for axial machine)
W = ṁ u ΔV_θ  (Euler)  — blade speed u same at inlet and outlet`],
        ["Specific speed N_s",
`N_s = N√Q / H^(3/4)  (pumps);  N_s = N√W / H^(5/4)  (turbines)
Classifies turbomachinery type by operating point
Low N_s → centrifugal;  High N_s → axial; intermediate → mixed-flow`],
      ]}/>

      {/* ── Navier-Stokes ── */}
      <h2 style={S.h2}>Navier-Stokes Equations</h2>
      <p style={S.p}>
        The Navier-Stokes (N-S) equations are the full differential form of Newton's second law applied
        to a viscous fluid. They are the governing equations of all fluid motion. Exact analytical solutions
        exist only for a handful of simple geometries; for complex flows, numerical (CFD) methods are required.
      </p>
      <DiagramNavierStokes/>
      <Table2 rows={[
        ["N-S equations (incompressible)",
`ρ(∂V/∂t + (V·∇)V) = −∇P + μ∇²V + ρg
Left: mass × acceleration (inertia)
Right: pressure gradient + viscous diffusion + body force
Must be solved simultaneously with continuity ∇·V = 0`],
        ["Euler's equation (inviscid)",
`ρ DV/Dt = −∇P + ρg
Navier-Stokes with μ = 0 (frictionless)
Integrating along streamline → Bernoulli's equation`],
        ["Couette flow (exact solution)",
`Flow between parallel plates; top plate moves at U, bottom fixed
u(y) = U·y/h  (linear profile)
τ_wall = μU/h;  No pressure gradient required
Re_Couette = ρUh/μ;  laminar for Re < 1500`],
        ["Hagen-Poiseuille flow (exact solution)",
`Fully developed laminar flow in a circular pipe
u(r) = (R²−r²)·(−dP/dx)/(4μ)
u_max = R²(−dP/dx)/(4μ)  at centreline (r=0)
Q = πR⁴(−dP/dx)/(8μ)  =  πD⁴ΔP/(128μL)`],
        ["Hagen-Poiseuille — key results",
`Average velocity: V̄ = u_max/2 = R²(−dP/dx)/(8μ)
Wall shear stress: τ_w = R(−dP/dx)/2 = 4μV̄/R
Friction factor: f = 64/Re  (Darcy; Re = ρV̄D/μ)
Valid for Re < 2300 (laminar regime)`],
        ["Dimensional analysis of N-S",
`Non-dimensionalise: Reynolds number Re = ρVL/μ
N-S in dimensionless form: (1/Re)∇²V* − ∇P* + …
High Re: inertia dominates (turbulent tendency)
Low Re: viscosity dominates (Stokes/creeping flow)`],
      ]}/>

      {/* ── Summary ── */}
      <h2 style={S.h2}>Key Formulae Summary</h2>
      <InfoBox title="MOMENTUM & FORCES — QUICK REFERENCE" items={[
        "Reynolds Transport Theorem:       dB/dt = ∂/∂t ∫ρb dV + ∯ρb(V·n̂) dA",
        "Steady-flow momentum:             ΣF = Σṁ_out V_out − Σṁ_in V_in",
        "Force on stationary flat plate:   F = ρAV² = ṁV",
        "Force on moving plate:            F = ρA(V−u)²;  max power at u = V/3 (single plate)",
        "Series of moving vanes:           F = ρA(V−u)²;  max power at u = V/2",
        "Curved vane x-force:              F_x = ṁ_rel(V−u)(1−cosβ)",
        "Angular momentum (torque):        T = ṁ(r₂V_θ2 − r₁V_θ1)",
        "Euler turbomachine head:          H = (u₂V_θ2 − u₁V_θ1)/g",
        "Navier-Stokes (incompressible):   ρDV/Dt = −∇P + μ∇²V + ρg",
        "Couette flow profile:             u(y) = Uy/h",
        "Hagen-Poiseuille profile:         u(r) = (R²−r²)(−dP/dx)/(4μ)",
        "Hagen-Poiseuille flow rate:       Q = πD⁴ΔP/(128μL);  f = 64/Re",
      ]}/>
    </div>
  );
}